module.exports = __webpack_public_path__ + "static/media/co1.1e042072.jpg";